import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';  
import { jwtDecode } from 'jwt-decode';



export interface JwtPayload {
  exp: number; // Expiration timestamp
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})


export class AuthService { 
 
 
  constructor(private http: HttpClient) {}

  login(username: string, password: string) {
    return this.http.post<{ token: string }>(`${environment.apiBaseUrl}auth/login`, { username, password })
      .pipe(tap(res => localStorage.setItem('token', res.token)));
  }

  getToken() {
    return localStorage.getItem('token');
  }

  isLoggedIn(): boolean {
    return !this.isTokenExpired();
  }

  logout() {
    localStorage.removeItem('token');
  }

  isTokenExpired(): boolean {
    const token = this.getToken();
    if (!token) return true;
  
    try {
      const decoded: JwtPayload = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000); // seconds
      return decoded.exp < now;
    } catch (err) {
      return true; // assume expired on error
    }
  }

}
